class InlineTable {

  /**
   * Constructor gets an element (table) by its id attribute from the document.
   *
   * @param {string} elemId
   */
  constructor(elemId) {
    this.el = document.querySelector(elemId);
  }

  /**
   * Check if a table is already inline.
   *
   * @return {bool} true when the table's parent has a 'data-role' of 'inline-table-item'
   */
  isAlreadyInline() {
    return (typeof this.el.parentNode.getAttribute('data-role') !== 'undefined') &&
      this.el.parentNode.getAttribute('data-role') === 'inline-table-item';
  }

  /**
   * Toggle the table's parent 'aria-selected' to be hidden and also updates the text content.
   *
   * @return {undefined}
   */
  setLinkToHidden() {
    const parentNode = this.el.parentNode.querySelector('[data-role="inline-table-item-link"]');
    parentNode.setAttribute('aria-selected', 'false');
    parentNode.textContent = parentNode.getAttribute('data-toggle-open-label');
  }

  /**
   * Insert the table back into the table group.
   *
   * @param {Object} element
   */
  insertInGroup(element) {
    element.insertBefore(this.el, element.childNodes[0]);
  }

  /**
   * Insert the table inline for a given element.
   *
   * @param {Object} element
   */
  insertInline(element) {
    element.parentNode.insertBefore(this.el, element.nextElementSibling);
  }
}

export default InlineTable;
